<template>
  <div class="container" @mouseenter="btnShow = true" @mouseleave="btnShow = false">
    <div class="image-wrapper">
      <!--尺寸 w 200px-->
      <el-badge class="mark" type="primary" value="碗碟" v-if="image.dish_type === '1'"/>
      <el-badge class="mark" type="danger" value="内容" v-if="image.dish_type === '2'"/>
      <img class="image-item" v-lazy="image.dish_image_url ? image.dish_image_url : image.dish_url" alt="" :key="image.dish_image_url ? image.dish_image_url : image.dish_url">
       <div class="btn-wrapper" v-if="btnShow">
        <el-button type="text" class="btn" icon="el-icon-zoom-in" @click.stop="getInfo"></el-button>
      </div>
    </div>
    <el-dialog
      title="标准碗碟详细信息"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="70%">
      <el-row class="dish-desc">
        <div class="image-wrapper-1">
      <!--尺寸 w 200px-->
          <img  class="image-item" v-lazy="image.dish_image_url ? image.dish_image_url : image.dish_url" alt="" :key="image.dish_image_url ? image.dish_image_url : image.dish_url">
          <!--<img  class="image-item" :src="image.dish_image_url ? image.dish_image_url : image.dish_url" alt="">-->
        </div>
        <div class="desc-wrapper">
          <p>名字(碗碟库): <span class="desc-detail">{{image.dish_native_name || '暂无'}}</span></p>
          <p>名字(餐厅内): <span class="desc-detail">{{image.dish_name || '暂无'}}</span></p>
          <p>备注: <span class="desc-detail">{{image.dish_desc || '暂无'}}</span></p>
          <p>识别模式: <span class="desc-detail danger-text">{{image.dish_type === '1' ? '碗碟识别' : '内容识别'}}</span></p>
          <p><span class="desc-detail danger-text">{{classId}}</span></p>
        </div>
        <div class="canteen-wrapper">
          <h3 class="title">绑定餐厅列表 <el-badge class="mark" :value="bindCanteenList.length"/></h3>
          <p v-for="canteen in bindCanteenList" :key="canteen.canteen_id">{{canteen.eatery_name + '------'+ canteen
            .canteen_name}}</p>
        </div>
      </el-row>
      <h3 class="header-text">随机获取的20张已标注的碗碟图片 <el-badge class="mark" :value="imgCount"/></h3>
        <el-button class="btn-inner" type="text" @click="getMarkedImage"><i class="el-icon-ali-refresh"></i>换一批</el-button>
        <el-button class="btn-inner" type="text" @click="migrationCheck" :disabled="imgCount === 0 ">数据清洗
        </el-button>
      <div class="marked-image-wrapper">
        <div @mouseover="showImageText(idx)" class="image-item-wrapper" v-for="(image, idx) in markedImageList"
             :key="image">
          <img
            v-lazy="image"
            class="image-item"
          />
          <div @mouseleave="hideImageText" v-if="textShow && idx ===currentImageIndex" class="text-on-image"
               @click="setAsCover(image)">
            设为封面
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  apiEditClassDish,
  apiGetBindCanteenListByClassId,
  apiGetImgCountByClassId,
  apiGetMarkedImagesByClassId
} from '@/api';

export default {
  name: 'classDishWrapper',
  components: {},
  props: {
    image: {
      type: Object
    },
    lazyMode: false
  },
  data () {
    return {
      bindCanteenList: [],
      btnShow: false,
      imgCount: 0,
      currentImageIndex: '',
      textShow: false,
      dialogVisible: false,
      markedImageList: []
    };
  },
  mounted () {
    // this.getBindCanteenList();
  },
  methods: {
    migrationCheck () {
      this.$router.push({
          name: 'migrationCheck',
          params: {
            class_dish: this.image
          }
        });
    },
    async setAsCover (img) {
      // let image = this.image;
      // console.log(image);
      let class_id = this.image.class_id;
      try {
        await apiEditClassDish(
          {
            class_id,
            class_meta_info: {
              dish_image_url: img
            },
            apiKey: this.apiKey
          }
        );
        if (this.image.hasOwnProperty('dish_image_url')) {
          this.image.dish_image_url = img;
        } else {
          this.image.dish_url = img;
        }
        this.$emit('changeImage', {img, class_id});
        this.$message.warning('修改成功');
      } catch (e) {
        this.$message.error('修改失败' + e.message);
      }
    },
    showImageText (idx) {
      this.currentImageIndex = idx;
      this.textShow = true;
    },
    hideImageText () {
      this.textShow = false;
      this.currentImageIndex = '';
    },
    async getBindCanteenList () {
      try {
        const res = await apiGetBindCanteenListByClassId(this.image.class_id);
        this.bindCanteenList = res.canteen_info_list;
      } catch (e) {
        this.$message.error('查询正在使用的餐厅失败' + e.message);
      }
    },
    async getImageCount () {
      let res = await apiGetImgCountByClassId(this.classId);
      this.imgCount = res.img_count;
    },
    getInfo () {
      this.dialogVisible = true;
      this.getImageCount();
      this.getBindCanteenList();
      this.getMarkedImage();
    },
    async getMarkedImage () {
      try {
        this.markedImageList = Array(20).map(_ => 0);
        let res = await apiGetMarkedImagesByClassId(this.classId);
        this.markedImageList = res.img_url_list;
      } catch (e) {
      }
    }
  },
  computed: {
    classId () {
      return this.image.class_id ? this.image.class_id : this.image.class_uuid;
    },
    apiKey () {
      return this.$store.getters.userinfo().api_key;
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
  /*@import "//at.alicdn.com/t/font_1048211_fgfomrf6w8m.css";*/
  .container {
    .image-wrapper {
      display: inline-block;
      position: relative;
      width: 100%;
      height: 100%;
      text-align: center;
      .mark {
        position: absolute;
        right: -20px;
        bottom: 0;
        z-index: 10;
      }
      .text-wrapper {
        width: 200px;
        position: absolute;
        right: 0;
        top: 0;
        text-align: right;
        background-color: #fff;
        .text {
          font-size: 60%;
          padding: 0;
          margin: 0;
          font-weight: 700;
        }
      }
      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      .btn-wrapper {
        position: absolute;
        z-index: 10;
        left: 0;
        top:0;
        .btn {
          font-size: 20px;
          font-weight: 800;
          background-color: #fff;
          padding: 0;
        }
      }
    }
  }
  .dish-desc {
    .desc-wrapper {
      display: inline-block;
      width: 400px;
      height: 200px;
      padding: 10px;
      vertical-align: top;
    }
    .canteen-wrapper {
      display: inline-block;
      vertical-align: top;
      height: 200px;
      position: relative;
      overflow-y: scroll;
      .title {
        color: $primary;
      }
    }
    .image-wrapper-1 {
      display: inline-block;
      width: 200px;
      height: 200px;
      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        &[lazy=error] {
          /*your style here*/
          width: 100%;
          height: 100%;
          background-color: rgba(239, 239, 239, 1);
        }
        &[lazy=loading] {
          /*your style here*/
          width: 100%;
          height: 100%;
          background-color: rgba(239, 239, 239, 1);
        }
      }
    }
  }
  .marked-image-wrapper {
    .image-item-wrapper {
      display: inline-block;
      vertical-align: top;
      width: 100px;
      height: 100px;
      padding: 5px;
      position: relative;
      .text-on-image {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        display: -moz-box;
        text-align: center;
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: center;
        display: -moz-box;
        -moz-box-align: center;
        -moz-box-pack: center;
        -o-box-align: center;
        -o-box-pack: center;
        -ms-box-align: center;
        -ms-box-pack: center;
        box-align: center;
        box-pack: center;
        color: red;
        cursor: pointer;
      }
      .image-item {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        &[lazy=error] {
          /*your style here*/
          width: 100%;
          height: 100%;
          background-color: rgba(239, 239, 239, 1);
        }
        &[lazy=loading] {
          /*your style here*/
          width: 100%;
          height: 100%;
          background-color: rgba(239, 239, 239, 1);
        }
      }
    }
  }
  .header-text {
    display: inline-block;
  }
  .btn-inner {
    display: inline-block;
  }
</style>
